/**
 * @file    pages/style.css - Styling for pages.
 * @author  Danny Akbarzadeh <danny@kingsds.network>
 * @author  Arnab Sagar <arnab@kingsds.network>
 * @date    June 2022
 */

.accounts-page {
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 0 40px;
  margin-right: 0;
  max-width: 2500px;
}

@media only screen and (max-width: 1024px) {
  .accounts-page {
    grid-template-columns: 1fr;
  }
}

.userSettings h2 {
  color: var(--content-hue-dark);
  font-size: 1em;
  margin-block-start: 0;
  margin-block-end: 0.2rem;
  width: 100%;
}

.userSettings .inlineinput.textinput {
  margin-right: 2%;
}

.userSettings .form-row {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

.userSettings .form-row:nth-child(3) .inlineinput:first-child {
  min-width: 28%;
  max-width: 28%;

}

.userSettings .form-row:not(:nth-child(3)) .textinput {
  width: 28%;
}

@media only screen and (max-width: 1000px){
  .userSettings .form-row:nth-child(3) {
    flex-wrap: wrap;
  }

  /* the second selector after the comma is necessary in order to ensure enough specificity to affect the third profile row */
  .userSettings .form-row .textinput.inlineinput,
  .userSettings .form-row:nth-child(3) .textinput.inlineinput {
    min-width: 48%;
    max-width: 48%;
  }
}

@media only screen and (max-width: 480px) {
  .userSettings .form-row {
    display: block;
  }

  .userSettings .form-row .textinput.inlineinput,
  .userSettings .form-row:nth-child(3) .textinput.inlineinput {
    min-width: 100%;
    max-width: 100%;
  }

  .accounts-page {
    grid-template-columns: 1fr;
  }
}

div.data {
  word-wrap: break-word;
}

.userSettings .userContent {
  margin-bottom: 2%;
}

.userSettings form {
  align-items: flex-end;
}

.buttonsFlex {
  display: flex;
  gap: 1em;
}

.bolded { 
  font-family: "Proxima Nova Bold"; 
  font-weight: 100
}

.boldedDate {
  font-family: "Proxima Nova Bold";
  font-weight: 900
}

.privacyPolicy h2 {
  margin-top: 2em;
  margin-bottom: 1em;
  font-size: 1em;
}

.privacyPolicy p {
  margin-top: 1em;
  margin-bottom: 1em;
}

.termsOfService h2 {
  margin-top: 2em;
  margin-bottom: 1em;
  font-size: 1em;
}

.termsOfService p {
  margin-top: 1em;
  margin-bottom: 1em;
}

.termsOfService li {
  list-style-type: unset;
}
